<template>
  <div id="main-content">
    <div style="display: flex;background: #FFFFFF;padding: 10px;cursor: pointer">
      <div class="my-group">
        <div class="my-group-item my-group-item-left" :class="type==='ad_spend'?'active':''" @click="type='ad_spend'">广告投放</div>
        <div class="my-group-item my-group-item-right" :class="type==='ad_rebate'?'active':''" @click="type='ad_rebate'">广告返点</div>
      </div>
      <a-radio-group button-style="solid" v-model="cate" @change="initData" style="margin-left: 10px;">
          <a-radio-button value="">
            全部
          </a-radio-button>
          <a-radio-button value="game">
            游戏
          </a-radio-button>
          <a-radio-button value="ai">
            AI
          </a-radio-button>
        </a-radio-group>
      <div class="my-year" >
        {{year}}年<a-icon type="down" />
        <div class="my-year-list">
          <div :class="i===3?'active':''"
               v-for="i in 5" @click="year=year+i-3">{{year+i-3}}</div>
        </div>
      </div>
      <div style="flex: 1"></div>
      <div class="my-button" @click="downloadReport()">
        下载
      </div>
    </div>
    <div class="gb-table-panel" style="margin-top: 10px;background: #FFFFFF;">
      <div class="gb-table-content" >
        <div class="gb-table-list" style="background: #E5E5E5;position: absolute;top:0px;">
          <div class="gb-table-item" style="width: 100px;">渠道</div>
          <div class="gb-table-item" >账户</div>
          <div class="gb-table-item" v-for="month in 12">{{month}}月</div>
        </div>
        <a-spin v-if="dataLoading" style="width: 100%;margin-top: 20px;"></a-spin>
        <div v-else class="gb-table-list" v-for="(dataItem,dataIndex) in  dataList">
          <div class="gb-table-item" style="width: 100px;">
            {{dataItem.name}}
          </div>
          <div class="gb-table-item">
            <div style="display: flex;flex-flow: column;height: 100%;">
              <div style="border-bottom: 1px solid #FFFFFF;flex: 1;cursor: pointer" v-for="(dataItemItem,dataItemIndex) in dataItem.children">
                {{dataItemItem.name}}
              </div>
            </div>
          </div>
          <div class="gb-table-item" v-for="month in 12">
            <div style="display: flex;flex-flow: column;height: 100%;">
              <div style="border-bottom: 1px solid #FFFFFF;flex: 1;word-break:break-all" v-for="(dataItemItem,dataItemIndex) in dataItem.children">
                {{dataItemItem.children[month]?dataItemItem.children[month]:'&nbsp;'}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {GetSettlementMonthData} from "../../../api/v1/home_api";

export default {
  name: "Agent",
  data(){
    return {
      year:2022,
      cate:'',
      dataList:{},
      dataLoading:false,
      type:'ad_spend'
    }
  },
  watch:{
    type:{
      handler:function (value,oldVal){
        this.initData()
      }
    },
    year:{
      handler:function (value,oldVal){
        this.initData()
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods:{
    initData(){
      if (this.dataLoading) return
      this.dataLoading = true
      this.dataList = {}
      GetSettlementMonthData({
        type:this.type,
        year:this.year,
        cate:this.cate
      }).then(resp => {
        this.dataLoading = false
        if (resp.code===200){
          this.dataList = resp.data
        }
      })
    },
    downloadReport(){
      let _name = this.type==='ad_cash'?'广告收益':(this.type==='ad_spend'?'广告推广':'内购')
      _name += ' '+this.year+'年 Beta 结算核对'
      var _data_list = []
      var _data_field = [
        {
          dataIndex:'channel',
          title:'渠道'
        },
        {
          dataIndex:'account',
          title:'账户'
        },
      ]
      for (let _m=1;_m<=12;_m++){
        _data_field.push({
          dataIndex: _m+'M',
          title: _m+'月'
        })
      }
      Object.values(this.dataList).forEach(channel_item => {
        Object.values(channel_item.children).forEach(account_item => {
          let _data_item = {}
          Object.keys(account_item.children).forEach(month_key=>{
            _data_item[month_key+'M'] = account_item.children[month_key]
          })
          _data_item['channel'] = channel_item.name
          _data_item['account'] = account_item.name
          _data_list.push(_data_item)
        })
      })
      this._export_cvs(_data_list,_data_field,_name)
    }
  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/views/Spend/Check/Agent.vue